import JSZip from 'jszip'

export const downloadFile = (uri, filename) => {
  const link = document.createElement('a')
  link.setAttribute('href', uri)
  link.setAttribute('download', filename)
  link.setAttribute('target', '_blank')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const fetchBlobs = async files => {
  const blobs = []
  await Promise.all(
    files.map(async file => {
      const res = await fetch(file.url)
      const blob = await res.blob()
      blobs.push({
        name: file.name,
        blob,
      })
    })
  )

  return blobs
}

const pack = async blobs => {
  const zip = new JSZip()
  const folder = zip.folder('attachments')
  blobs.forEach(blob => folder.file(blob.name, blob.blob))
  const zipBlob = await zip.generateAsync({ type: 'blob' })
  return zipBlob
}

export const downloadFiles = async files => {
  const blobs = await fetchBlobs(files)
  const zipFile = await pack(blobs)
  const link = document.createElement('a')
  link.setAttribute('href', URL.createObjectURL(zipFile))
  link.setAttribute('download', 'attachments')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
